module.exports = "/images/moe-logo.png?40f8a6b0e7b5fac742ed081cddcbfa47";